import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMedia } from '../../common/interfaces/Media.interface';

interface ModalState {
  modalType: 'view' | 'add' | null;
  selectedItem: IMedia | null;
}

const initialState: ModalState = {
  modalType: null,
  selectedItem: null,
};

const modalMediaSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (
      state,
      action: PayloadAction<{
        modalType: 'view' | 'add';
        selectedItem?: IMedia;
      }>
    ) => {
      state.modalType = action.payload.modalType;
      state.selectedItem = action.payload.selectedItem || null;
    },
    closeModal: (state) => {
      state.modalType = null;
      state.selectedItem = null;
    },
  },
});

export const { openModal, closeModal } = modalMediaSlice.actions;
export default modalMediaSlice.reducer;
